import React from 'react'
import Page from '../Page'

const HighC = ({ testResult }) => {
    return (
        <>
            <Page
                testResult={testResult}
                title="معرفی الگوی رفتاری High C"
            >
                <p className="text-gray-800 leading-7">
                    افراد دارای الگوی رفتاری  High C، ذهنی تحلیل‌گر، منطقی و ساختارمند دارند. آن‌ها در جست‌وجوی «درستی، دقت و کیفیت بالا» هستند. این افراد به استانداردها، قوانین و چارچوب‌های مشخص اهمیت فراوانی می‌دهند و کمتر کاری را بدون برنامه و دلیل انجام می‌دهند. تصمیمات آن‌ها معمولاً پس از تحلیل دقیق اطلاعات و بررسی تمام جوانب گرفته می‌شود.
                </p>

                <p className="text-gray-800 leading-7">
                    در جمع ممکن است فردی رسمی، کم‌حرف، متمرکز و حتی کمی جدی به‌نظر برسند، اما پشت این ظاهر، ذهنی بسیار عمیق و سازمان‌یافته وجود دارد. برای آن‌ها «صحت» مهم‌تر از «سرعت»، و «کیفیت» مهم‌تر از «هیجان» است.
                </p>
            </Page>

            <Page
                testResult={testResult}
                title="ویژگی کلیدی تیپ High C"
            >
                <ul className="text-gray-800 leading-7 list-disc list-inside space-y-2">
                    <li>گرایش به کمال‌گرایی، تحلیل عمیق، و رفتار منطقی</li>
                    <li>تعهد بالا به انجام «کار درست» به «روش درست»</li>
                    <li>حساسیت بالا نسبت به اشتباه، خطا و بی‌نظمی</li>
                    <li>خجالتی یا محتاط در روابط، اما متعهد و قابل اعتماد</li>
                </ul>
            </Page>

            <Page
                testResult={testResult}
                title="در محیط کاری یا اجتماعی، افراد High C معمولاً"
            >
                <ul className="text-gray-800 leading-7 list-disc list-inside space-y-2">
                    <li>کار را بدون نقص و دقیق تحویل می‌دهند</li>
                    <li>زمان زیادی صرف جمع‌آوری داده‌ها و تحلیل می‌کنند</li>
                    <li>از اشتباه کردن واهمه دارند و معمولاً دیر تصمیم می‌گیرند</li>
                    <li>از فضاهای پرهیجان، غیرمنطقی یا بی‌برنامه دوری می‌کنند</li>
                    <li>اهل پرسیدن «چرا»های عمیق در هر کار هستند</li>
                </ul>
            </Page>

            <Page
                testResult={testResult}
                title="نقاط قوت High C"
            >
                <ul className="text-gray-800 leading-7 list-disc list-inside space-y-2">
                    <li>دقت، منطق، ساختار، تفکر نقادانه</li>
                    <li>مسئولیت‌پذیری بالا، پایبندی به استانداردها</li>
                    <li>توانایی خلق نظم در پروژه‌های پیچیده</li>
                    <li>تعهد به کیفیت در همه امور</li>
                </ul>
            </Page>

            <Page
                testResult={testResult}
                title="چالش‌ها و ریسک‌های رفتاری"
            >
                <ul className="text-gray-800 leading-7 list-disc list-inside space-y-2">
                    <li>وسواس بیش از حد روی جزئیات</li>
                    <li>تصمیم‌گیری با تأخیر به دلیل تحلیل بیش از حد</li>
                    <li>ناتوانی در پذیرش اشتباه یا سازگاری سریع با تغییر</li>
                    <li>واکنش سختگیرانه به بی‌نظمی یا بی‌دقتی دیگران</li>
                </ul>

                <p className="text-gray-800 leading-7 mt-4">
                    <strong>مثال کاربردی :</strong>
                    <br />
                    فرض کنید در یک تیم، پروژه‌ای دچار خطاهای فنی شده.  High C بلافاصله بررسی می‌کند که خطا از کجا بوده، مستندات قبلی را مطالعه می‌کند، و پیش از هرگونه اقدام، با دقت بسیار بالا یک برنامه اصلاحی تدوین می‌کند. اگر افراد تیم بخواهند سریع جلو بروند بدون تحلیل کافی،  High C ممکن است مقاومت کند یا با اضطراب واکنش دهد.
                </p>
            </Page>

            <Page
                testResult={testResult}
                title="فیلم پیشنهادی"
            >
                <p className="text-gray-800 leading-7">
                    A Beautiful Mind ذهن زیبا، شخصیت «جان نش» با رفتار تحلیلی، دقیق، درون‌گرا و قانون‌مندش تصویری زیبا و الهام‌بخش از یک  High C متفکر و درگیر با وسواس ذهنی ارائه می‌دهد.
                </p>
            </Page>

            <Page
                testResult={testResult}
                title="ابعاد و توصیف ویژگی‌های رفتاری High C"
            >
                <div className="text-gray-800 leading-7 space-y-4">
                    <p>
                        افراد با تیپ High C، به‌عنوان دقیق‌ترین، محتاط‌ترین و قانون‌مندترین تیپ DISC شناخته می‌شوند. آن‌ها با تمرکز بر «چه درست است» نه «چه خوشایند است»، تلاش می‌کنند کیفیت، صحت و انضباط را در هر کاری حفظ کنند.
                    </p>

                    <div className="space-y-4">
                        <div>
                            <h4 className="font-semibold mb-2">۱. گرایش شدید به نظم و چارچوب</h4>
                            <p>
                                High Cها بدون دستورالعمل یا نقشه راه احساس سردرگمی می‌کنند. آن‌ها با وضوح، ساختار و قوانین زندگی می‌کنند و معمولاً در پروژه‌هایی که نیاز به دقت، پیگیری و استانداردسازی دارند، درخششی کم‌نظیر دارند.
                            </p>
                        </div>

                        <div>
                            <h4 className="font-semibold mb-2">۲. تفکر نقادانه و جست‌وجوی حقیقت</h4>
                            <p>
                                افراد High C سؤال می‌پرسند، تحقیق می‌کنند، صحت اطلاعات را بررسی می‌کنند و هر ادعایی را بدون شواهد نمی‌پذیرند. اگر جمله‌ای مثل «همه همین کارو می‌کنن» به آن‌ها گفته شود، معمولاً جواب می‌دهند:
                                <br />
                                «من کاری به بقیه ندارم، من باید مطمئن باشم درستش چیه.»
                            </p>
                        </div>

                        <div>
                            <h4 className="font-semibold mb-2">۳. دقیق، محتاط، کم‌ریسک</h4>
                            <p>
                                High Cها اهل شتاب‌زدگی نیستند. آن‌ها تا زمانی که تمام جوانب را نسنجند، تصمیمی نمی‌گیرند. این ویژگی در پروژه‌هایی مثل حسابداری، کنترل کیفیت، برنامه‌نویسی یا برنامه‌ریزی مالی یک مزیت فوق‌العاده است، اما در پروژه‌هایی که نیاز به انعطاف یا ریسک‌پذیری سریع دارد، ممکن است محدودیت ایجاد کند.
                            </p>
                        </div>

                        <div>
                            <h4 className="font-semibold mb-2">۴. میل به کنترل از طریق کیفیت، نه قدرت</h4>
                            <p>
                                برخلاف تیپ D که از طریق تصمیم‌گیری و قاطعیت کنترل را اعمال می‌کند، تیپ C از طریق دقیق بودن، تخصص و صحت عملکرد کنترل فضا را در دست می‌گیرد. اگر کارها اشتباه یا بی‌نظم پیش برود، High C احساس تهدید و فشار روانی شدیدی می‌کند.
                            </p>
                        </div>

                        <div>
                            <h4 className="font-semibold mb-2">۵. رفتار آرام، رسمی و گاهی سرد</h4>
                            <p>
                                High C ممکن است در جمع، کم‌حرف یا حتی کمی خشک به‌نظر برسد، اما این ظاهر سرد، ناشی از تمایل درونی او به دقت و محتاط‌بودن است. او با افراد بسیار هیجانی مثل High I یا بی‌برنامه مثل Low C راحت نیست و ممکن است درون‌گرایی‌اش باعث شود دیگران فکر کنند او مغرور یا بی‌احساس است.
                            </p>
                        </div>

                    </div>
                </div>
            </Page>

            <Page
                testResult={testResult}
                title=""
            >
                <div className="text-gray-800 space-y-4">
                    <div>
                        <h4 className="font-semibold mb-2">۶. کمال‌گرا، اما خودمنتقد</h4>
                        <p>
                            High Cها استانداردهایی بسیار بالا دارند، نه فقط برای دیگران، بلکه بیشتر از همه برای خودشان. اگر اشتباهی از آن‌ها سر بزند، ممکن است مدتی طولانی درگیر سرزنش درونی یا اصلاح کامل آن شوند.
                        </p>
                    </div>
                    <div>
                        <h4 className="font-semibold mb-2">جمع‌بندی رفتاری</h4>
                        <p>
                            High C مثل یک معمار دقیقی است که پیش از ساختن دیوار، تمام نقشه‌های زیرزمینی را بررسی می‌کند. ممکن است دیر شروع کند، اما وقتی شروع کرد، با نهایت دقت، کیفیت و دلسوزی کار را به پایان می‌رساند.
                            <br />
                            اگر High D راننده‌ی پرسرعت باشد، High C مهندس طراحی جاده است.
                            <br />
                            اگر High I بازیگر روی صحنه است، High C کارگردان پشت صحنه است.
                        </p>
                    </div>
                </div>
            </Page>

            <Page
                testResult={testResult}
                title="تشریح الگوی رفتاری High C"
            >
                <div className="text-gray-800 leading-7 space-y-4">
                    <p>
                        فرد با تیپ High C اساساً بر پایه منطق، نظم، دقت و استاندارد حرکت می‌کند. او پیش از هر اقدام، اطلاعات را می‌سنجد، پرسش‌های دقیق می‌پرسد، داده‌ها را تحلیل می‌کند و تا مطمئن نباشد تصمیم نمی‌گیرد.
                    </p>

                    <div className="space-y-4">
                        <div>
                            <h4 className="font-semibold mb-2">۱. تفکر پیش از اقدام؛ آرام ولی استوار</h4>
                            <p>
                                High C برخلاف افراد واکنشی، تصمیماتش را با پردازش ذهنی دقیق اتخاذ می‌کند. در ظاهر ممکن است کند یا تردید‌آمیز به نظر برسد، اما در واقع به‌دنبال این است که تصمیمی بگیرد که نه فقط مؤثر، بلکه بی‌نقص باشد.
                            </p>
                            <p>
                                <strong>مثال:</strong> در یک جلسه تیمی که همه نظر می‌دهند، High C تا زمانی که اطلاعات نداشته باشد، نظر نمی‌دهد. اما وقتی سخن می‌گوید، حرفش دقیق، مستدل و متمایز است.
                            </p>
                        </div>

                        <div>
                            <h4 className="font-semibold mb-2">۲. قانون‌مداری ذاتی</h4>
                            <p>
                                افراد High C تمایل دارند ابتدا قانون را بدانند، سپس در چارچوب آن حرکت کنند. تغییرات بدون منطق، تصمیمات بدون شفافیت یا ابهام در نقش‌ها آن‌ها را دچار اضطراب می‌کند.
                            </p>
                            <p>
                                <strong>جمله کلیدی یک High C:</strong> اول بگو دقیقاً از من چی می‌خوای، بعد من بهترین روش رو پیدا می‌کنم.
                            </p>
                        </div>

                        <div>
                            <h4 className="font-semibold mb-2">۳. مسئولیت‌پذیر، اما وسواسی</h4>
                            <p>
                                آن‌ها مسئولیت کارها را می‌پذیرند، ولی تمایل دارند همه‌چیز کامل انجام شود. این موضوع گاهی باعث وسواس رفتاری، تأخیر در تحویل کار یا نارضایتی از عملکرد تیم می‌شود، حتی اگر خروجی قابل‌قبول باشد.
                            </p>
                        </div>

                        <div>
                            <h4 className="font-semibold mb-2">۴. فاصله‌گذاری اجتماعی و هیجانی</h4>
                            <p>
                                High Cها عموماً با افراد جدید یا هیجانی فاصله دارند. آن‌ها برای ایجاد رابطه، نیاز به زمان، اعتماد و احترام متقابل دارند. ممکن است در ابتدا خشک، رسمی یا حتی سرد به‌نظر برسند، ولی در عمق، بسیار وفادار، محترم و عمیق‌اند.
                            </p>
                        </div>

                        <div>
                            <h4 className="font-semibold mb-2">۵. تحلیل‌گر، مستندساز، منطقی</h4>
                            <p>
                                وقتی مشکلی پیش می‌آید، High C دنبال مقصر نمی‌گردد؛ دنبال دلیل، الگو و اصلاح ساختار می‌گردد. او گزارش‌ها را دقیق می‌نویسد، مراحل را ثبت می‌کند و کار بدون سند یا مستندات برایش بی‌معناست.
                            </p>
                        </div>
                    </div>
                </div>
            </Page>

            <Page
                testResult={testResult}
                title="چالش‌های رفتاری High C در محیط کار"
            >
                <ul className="text-gray-800 leading-7 list-disc list-inside space-y-2">
                    <li>تأخیر در تصمیم‌گیری: به‌خاطر تحلیل‌های زیاد یا ترس از اشتباه</li>
                    <li>انتقادگری پنهان یا کمال‌گرایی آزاردهنده: برای خود یا دیگران</li>
                    <li>احساس عدم کفایت در محیط‌های پرشتاب یا هیجانی</li>
                    <li>گرایش به انزوا در محیط‌های بدون ساختار</li>
                    <li>واکنش دفاعی نسبت به انتقاد ناگهانی یا تغییرات بدون توضیح</li>
                </ul>
            </Page>

            <Page
                testResult={testResult}
                title="تشریح الگوی رفتاری High C"
            >
                <div className="text-gray-800 leading-7 space-y-4">
                    <div>
                        <h4 className="font-semibold text-gray-800 mb-2">تشبیه برای درک بهتر:</h4>
                        <p>
                            High C شبیه کسی است که وقتی دیگران «فکر می‌کنند» او هنوز «در حال طراحی نقشه دقیق مسیر است». شاید دیرتر راه بیفتد، اما کمتر به مانع برخورد می‌کند.
                        </p>
                    </div>

                    <div>
                        <h4 className="font-semibold text-gray-800 mb-2">پیشنهاد فیلم:</h4>
                        <p>
                            The Imitation Game شخصیت آلن تورینگ (با بازی بندیکت کامبربچ) نمونه عالی از یک     High C  ناب است: تحلیل‌گر، درون‌گرا، دقیق، حساس به منطق و جزئیات، و در عین حال از نظر احساسی پیچیده.
                        </p>
                    </div>
                </div>
            </Page>

            <Page
                testResult={testResult}
                title="انگیزه شما در تیپ High C"
            >
                <div className="text-gray-800 leading-7 space-y-4">
                    <p>
                        برای افراد با تیپ High C، انگیزه از درون می‌آید، از «درست بودن»، «مستدل بودن» و «با کیفیت بودن». آن‌ها برخلاف تیپ‌هایی مثل High D که به تسلط و قدرت انگیزه می‌گیرند یا High I که با ارتباط و توجه تغذیه می‌شوند، بیشتر با دقت، شفافیت، ساختار و کنترل درونی انگیزه می‌گیرند.
                    </p>

                    <div className="space-y-4">
                        <div>
                            <h4 className="font-semibold mb-2">۱. وضوح در هدف و روش انجام کار</h4>
                            <p>
                                High C وقتی به‌وضوح بداند «چه کاری باید انجام دهد» و «چگونه»، با تمام توان وارد عمل می‌شود. ابهام، برداشت‌های دوپهلو و دستورهای مبهم انرژی او را از بین می‌برد.
                            </p>
                            <p>
                                <strong>مثال:</strong> اگر فقط به او بگویید «این کارو انجام بده» ولی نگویید چطور، احتمال دارد کار را شروع نکند؛ ولی اگر دستورالعمل و استاندارد داشته باشد، بی‌نقص انجامش می‌دهد.
                            </p>
                        </div>

                        <div>
                            <h4 className="font-semibold mb-2">۲. فرصت برای ارائه کار دقیق و بدون اشتباه</h4>
                            <p>
                                افراد High C از انجام کارهایی که نیاز به «دقت بالا»، «جزئی‌نگری» و «استاندارد مشخص» دارد، لذت می‌برند. اگر این فرصت فراهم شود، احساس ارزشمندی می‌کنند.
                            </p>
                        </div>

                        <div>
                            <h4 className="font-semibold mb-2">۳. فضای امن، آرام، بدون تحمیل و پر از منطق</h4>
                            <p>
                                این تیپ از محیط‌های پرهیاهو، پرفشار یا احساسی گریزان است. در فضایی که منطق، داده و آرامش حاکم باشد، بالاترین بهره‌وری را دارند.
                            </p>
                        </div>

                        <div>
                            <h4 className="font-semibold mb-2">۴. احترام به تخصص و مرزهای حرفه‌ای</h4>
                            <p>
                                High C از این‌که به عنوان «متخصص» شناخته شود و دانش او جدی گرفته شود، احساس غرور می‌کند. اگر کسی بدون اطلاع تخصصی در حوزه او دخالت کند، حس تهدید پیدا می‌کند.
                            </p>
                        </div>

                        <div>
                            <h4 className="font-semibold mb-2">۵. امکان داشتن زمان برای بررسی، تحقیق و اصلاح</h4>
                            <p>
                                آن‌ها علاقه دارند پیش از تصمیم‌گیری، تحلیل کنند. اگر این زمان از آن‌ها گرفته شود، دچار اضطراب، واکنش سرد یا انفعال می‌شوند.
                            </p>
                            <p>
                                <strong>جمله انگیزشی مورد علاقه‌شان:</strong> «بذار چندتا گزینه رو بررسی کنم، بعد دقیق‌ترین تصمیم رو می‌گیرم.»
                            </p>
                        </div>
                    </div>
                </div>
            </Page>

            <Page
                testResult={testResult}
                title=""
            >
                <div className="text-gray-800 space-y-4">
                    <div>
                        <h4 className="font-semibold mb-2">چیزهایی که انگیزه High C را از بین می‌برد</h4>
                        <ul className="list-disc list-inside space-y-1">
                            <li>ابهام در دستور یا انتظار</li>
                            <li>رفتارهای هیجانی و بدون منطق</li>
                            <li>تحمیل عجولانه یا تحت فشار قرار دادن</li>
                            <li>نادیده گرفتن دقت، تخصص یا بازخوردهای فنی او</li>
                            <li>درخواست‌های سطحی مثل «ولش کن حالا، سریع انجام بده»</li>
                        </ul>
                    </div>

                    <div>
                        <h4 className="font-semibold mb-2">تشبیه کاربردی</h4>
                        <p>
                            انگیزه High C مثل آتش زیر خاکستر است: آرام اما پایدار. اگر با «اطمینان، برنامه و احترام» تغذیه شود، تبدیل به یک نیروی بی‌وقفه برای رشد و کیفیت می‌شود.
                        </p>
                    </div>

                    <div>
                        <h4 className="font-semibold mb-2">فیلم پیشنهادی</h4>
                        <p>
                            <em>Moneyball</em> – شخصیت «پیتر برند» (با بازی جونا هیل) نماینده‌ای عالی از High C است که با تحلیل داده، استدلال منطقی و تمرکز روی روش علمی، انگیزه می‌گیرد و تحول ایجاد می‌کند.
                        </p>
                    </div>
                </div>
            </Page>

            <Page
                testResult={testResult}
                title="عادت‌های کاری شما در تیپ High C"
            >
                <div className="text-gray-800 leading-7 space-y-4">
                    <p>
                        افراد High C به دلیل سبک فکری و شخصیتی خاص خود، عادت‌هایی دارند که آن‌ها را در محیط‌های کاری دقیق، مستند، منظم و استانداردمحور موفق می‌سازد. البته اگر این عادات تعدیل نشوند، ممکن است برای خودشان یا تیم‌شان محدودیت‌هایی ایجاد کنند.
                    </p>

                    <div className="space-y-4">
                        <div>
                            <h4 className="font-semibold mb-2">۱. کار دقیق، آهسته، ولی با کیفیت بالا</h4>
                            <p>
                                High Cها ترجیح می‌دهند آرام و با تمرکز کار کنند. درگیر چندوظیفگی نمی‌شوند مگر اینکه برنامه‌ای دقیق برای آن داشته باشند. کار را «تا مطمئن نباشند» تحویل نمی‌دهند.
                            </p>
                            <p>
                                <strong>مثال:</strong> اگر گزارشی را بنویسند، معمولاً آن را چند بار بازبینی و ویرایش می‌کنند تا اطمینان کامل پیدا کنند هیچ خطایی وجود ندارد.
                            </p>
                        </div>

                        <div>
                            <h4 className="font-semibold mb-2">۲. مستندسازی، مستندسازی، مستندسازی!</h4>
                            <p>
                                برای آن‌ها هیچ چیزی کامل نیست مگر اینکه ثبت و مستند شده باشد. صورتجلسه، فایل اکسل، نسخه پشتیبان و آرشیو اطلاعات بخش جدانشدنی از عادت‌های کاری‌شان است.
                            </p>
                        </div>

                        <div>
                            <h4 className="font-semibold mb-2">۳. علاقه به شروع با تحقیق و بررسی دقیق</h4>
                            <p>
                                قبل از آغاز هر پروژه، High C به‌دنبال داده، دستورالعمل، مستندات و مطالعه است. بدون آن وارد عمل نمی‌شود. این باعث می‌شود کارهایش دقیق و قابل دفاع باشد، اما گاهی هم باعث کندی در اقدام اولیه می‌شود.
                            </p>
                        </div>

                        <div>
                            <h4 className="font-semibold mb-2">۴. استفاده از چک‌لیست‌ها و سیستم‌های کنترلی</h4>
                            <p>
                                High C معمولاً برای خودش فرم، چک‌لیست یا فلوچارت تهیه می‌کند. هر کار باید با یک سیستم منطقی مدیریت شود. آن‌ها از برنامه‌ریزی دقیق لذت می‌برند و اگر سیستم بر هم بخورد، آرامش‌شان به‌هم می‌ریزد.
                            </p>
                        </div>

                        <div>
                            <h4 className="font-semibold mb-2">۵. کنترل کیفیت شدید – هم برای خود، هم دیگران</h4>
                            <p>
                                گاهی آن‌قدر درگیر کنترل و بازبینی کار خود یا دیگران می‌شوند که وارد فاز وسواس می‌گردند. انتقاد از دیگران اگر مدیریت نشود، ممکن است روابط‌شان را در تیم آسیب‌پذیر کند.
                            </p>
                        </div>
                    </div>
                </div>
            </Page>

            <Page
                testResult={testResult}
            >
                <div className="text-gray-800 leading-7 space-y-4">
                    <div>
                        <h4 className="font-semibold mb-2">۶. زمان‌بندی محتاطانه</h4>
                        <p>
                            افراد High C معمولاً زودتر از موعد پروژه را آغاز می‌کنند یا برای آن برنامه‌ریزی دارند. آن‌ها نمی‌گذارند کاری دقیقه نودی شود، مگر اینکه دیگران برنامه‌شان را خراب کرده باشند!
                        </p>
                    </div>

                    <div>
                        <h4 className="font-semibold mb-2">۷. محافظه‌کاری در اجرا و بیان</h4>
                        <p>
                            در ارائه ایده‌ها یا گزارش‌ها، زیاد اهل نمایش یا بیان احساسی نیستند. خروجی‌هایشان رسمی، مستدل و محتوایی است. بیشتر ترجیح می‌دهند کیفیت کارشان سخن بگوید تا خودشان.
                        </p>
                    </div>

                    <div>
                        <h4 className="font-semibold mb-2">نقاط قوت عادت‌های کاری High C</h4>
                        <ul className="list-disc list-inside space-y-1">
                            <li>دقت بالا، قابلیت اعتماد، پاسخ‌گویی قوی</li>
                            <li>کنترل کیفیت و پیشگیری از خطا</li>
                            <li>تحلیل عمیق و بررسی پیامدها</li>
                            <li>ساختاردهی به تیم یا پروژه</li>
                        </ul>
                    </div>

                    <div>
                        <h4 className="font-semibold mb-2">چالش‌های احتمالی</h4>
                        <ul className="list-disc list-inside space-y-1">
                            <li>تأخیر در تحویل به دلیل حساسیت بیش از حد</li>
                            <li>وسواس روی جزئیات به جای دیدن تصویر کلی</li>
                            <li>مقاومت در برابر روش‌های جدید بدون تحلیل کافی</li>
                            <li>سختگیری نسبت به دیگرانی که دقیق نیستند</li>
                        </ul>
                        <p>
                            High C ها بیشتر «آرشیو» می‌سازند تا «تبلیغ»؛ برای رشدشان باید یاد بگیرند گاهی به‌جای تمرکز افراطی روی کامل بودن، «اقدام به‌موقع» را در اولویت بگذارند.
                        </p>
                    </div>

                    <div>
                        <h4 className="font-semibold mb-2">پیشنهاد فیلم</h4>
                        <p>
                            <em>Bridge of Spies</em> – شخصیت وکیل (تام هنکس) که با دقت، مدارک، تحلیل قانونی و بدون هیجان، کارش را پیش می‌برد، نماینده رفتاری تیپ High C در مواجهه با تصمیمات پرچالش است.
                        </p>
                    </div>
                </div>
            </Page>

            <Page
                testResult={testResult}
                title="دیدگاه‌های شما در تیپ High C"
            >
                <div className="text-gray-800 leading-7 space-y-4">
                    <p>
                        High Cها دنیا را از پشت عینک دقت، منطق، شواهد و چارچوب می‌بینند. آن‌ها با تحلیل، قضاوت محتاطانه و نیاز به اطمینان، تصمیم می‌گیرند چگونه با دیگران و مسائل برخورد کنند. دیدگاه آن‌ها اغلب بی‌طرف، منطقی و استانداردمحور است، اما اگر مدیریت نشود، ممکن است به بدبینی، کمال‌گرایی و فشار درونی تبدیل شود.
                    </p>

                    <div className="space-y-4">
                        <div>
                            <h4 className="font-semibold mb-2">۱. «دنیای خوب، دنیای دقیق است.»</h4>
                            <p>
                                High C معتقد است اگر افراد با هم منظم، درستکار و با‌برنامه باشند، کارها بهتر پیش می‌رود. بی‌نظمی، شتاب‌زدگی، کارهای سطحی و تصمیمات احساسی، برای او نشانه ضعف سیستم یا بی‌مسئولیتی است.
                            </p>
                        </div>

                        <div>
                            <h4 className="font-semibold mb-2">۲. «احساسات ارزشمندند، اما اثبات‌پذیر نیستند!»</h4>
                            <p>
                                این تیپ احساس دارد، اما آن را در اولویت تصمیم‌گیری قرار نمی‌دهد. اگر کسی با احساسات زیاد بخواهد حرفی را اثبات کند، High C ممکن است آن را رد کند یا بی‌تفاوت باشد.
                            </p>
                            <p>
                                <strong>مثال:</strong> اگر بگویند «من حس می‌کنم این طرح عالیه»، ممکن است پاسخ دهد: «حس‌تو محترمه، اما آیا داده‌ای هم هست که نشون بده عالیه؟»
                            </p>
                        </div>

                        <div>
                            <h4 className="font-semibold mb-2">۳. «هر چیزی باید مستند باشد.»</h4>
                            <p>
                                آن‌ها به نوشته، سند، قانون، منبع موثق و منطق اعتقاد دارند. نظر شخصی را فقط وقتی می‌پذیرند که پشتوانه‌ای داشته باشد. در کار تیمی، اگر داده‌ای برای تصمیم نباشد، ترجیح می‌دهند اقدام نکنند.
                            </p>
                        </div>

                        <div>
                            <h4 className="font-semibold mb-2">۴. «خطای کوچک = بی‌دقتی بزرگ.»</h4>
                            <p>
                                حتی اشتباهات جزئی در نوشتار، محاسبه، ارائه یا استدلال برای High C نشانه‌ای از بی‌اعتباری کل محتواست. درنتیجه، گاهی خیلی زود به افراد برچسب «بی‌دقت» یا «غیرحرفه‌ای» می‌زنند.
                            </p>
                        </div>

                        <div>
                            <h4 className="font-semibold mb-2">۵. «ارزش انسان به مسئولیت‌پذیری و صداقت اوست.»</h4>
                            <p>
                                برخلاف تیپ‌هایی که جذابیت، شجاعت یا نتیجه را ملاک ارزش می‌دانند، High C بیشتر به تعهد، انضباط، وفاداری به اصول و رعایت چارچوب‌ها اهمیت می‌دهد. برای او «ادب»، «دقت در قول‌ و قرار»، و «صراحت مودبانه» مهم‌ترین مؤلفه‌های شخصیت حرفه‌ای است.
                            </p>
                        </div>
                    </div>
                </div>
            </Page>

            <Page
                testResult={testResult}
            >
                <div className="text-gray-800 space-y-4">
                    <div>
                        <h4 className="font-semibold mb-2">۶. «با تغییرات احساسی یا ناگهانی کنار نمی‌آید.»</h4>
                        <p>
                            High C اگر قرار باشد ناگهان برنامه‌ای عوض شود یا مسیر کاری تغییر کند، ابتدا به دنبال دلایل و پیامدهای آن می‌گردد. اگر اقناع نشود، ممکن است مقاومت کند یا کناره‌گیری کند.
                        </p>
                    </div>

                    <div>
                        <h4 className="font-semibold mb-2">۷. «نقد را دوست دارد، اگر محترمانه و منطقی باشد.»</h4>
                        <p>
                            برخلاف برخی تیپ‌ها که با انتقاد شخصی آسیب می‌بینند، High C اگر ببیند نقد فنی و با مستندات است، آن را می‌پذیرد. اما اگر نقد احساسی، مبهم یا بدون داده باشد، آن را بی‌ارزش می‌داند.
                        </p>
                    </div>

                    <div className="mt-6">
                        <p>
                            دیدگاه High C را می‌توان با این جمله خلاصه کرد:
                            <em>«من تا مطمئن نباشم، نمی‌گویم؛ اما وقتی گفتم، رویش حساب کن.»</em>
                        </p>
                        <p className="mt-2">
                            فیلم پیشنهادی برای درک دیدگاه High C: <strong>«The Post»</strong> شخصیت بن بردلی (سردبیر واشنگتن پست) در برخورد با انتشار اسناد پنهان دولتی، با دقت، تحلیل حقوقی، اخلاق حرفه‌ای و استدلال ساختارمند عمل می‌کند. تصویری عالی از فردی با نگرش High C در شرایط بحرانی.
                        </p>
                    </div>
                </div>
            </Page>

            <Page
                testResult={testResult}
                title="اوقات فراغت در تیپ High C"
            >
                <div className="text-gray-800 leading-7 space-y-4">
                    <p>
                        افراد High C حتی در اوقات فراغت نیز به ساختار، هدفمندی و کنترل علاقه دارند. برای آن‌ها «تفریح واقعی» یعنی زمانی که ذهن‌شان در آرامش، اما همچنان درگیر با نظم، یادگیری، یا عمق باشد. آن‌ها از هیاهو یا برنامه‌های شلوغ و بی‌هدف بیزارند.
                    </p>

                    <div className="space-y-4">
                        <div>
                            <h4 className="font-semibold mb-2">۱. علاقه به فعالیت‌های ذهنی و عمیق</h4>
                            <p>
                                High C در اوقات فراغت از فعالیت‌هایی مثل مطالعه عمیق، مستندسازی، حل پازل، تماشای فیلم‌های تحلیلی یا انجام بازی‌های استراتژیک لذت می‌برد. هر چیزی که ذهنش را درگیر کند، ولی در فضایی آرام و قابل‌پیش‌بینی.
                            </p>
                        </div>

                        <div>
                            <h4 className="font-semibold mb-2">۲. نیاز به خلوت و سکوت برای شارژ شدن</h4>
                            <p>
                                اوقات فراغت برای آن‌ها فرصتی برای «خارج شدن از شلوغی و پردازش اطلاعات» است. یک پیاده‌روی در طبیعت با هدف نظم ذهن، یا نشستن در اتاق ساکت با موسیقی ملایم، می‌تواند بهترین تفریح آن‌ها باشد.
                            </p>
                        </div>

                        <div>
                            <h4 className="font-semibold mb-2">۳. تفریح‌های دقیق و فنی را ترجیح می‌دهند</h4>
                            <p>
                                مانند نجاری، ساخت ماکت، کارهای مکانیکی دقیق، یا حتی عکاسی منظره. فعالیت‌هایی که بتوانند با تمرکز، جزئی‌نگری و بدون فشار هیجانی انجام دهند.
                            </p>
                        </div>

                        <div>
                            <h4 className="font-semibold mb-2">۴. گریز از جمع‌های پر سر و صدا</h4>
                            <p>
                                High Cها معمولاً از مهمانی‌های بزرگ، مکان‌های شلوغ، یا جمع‌های بی‌برنامه اجتناب می‌کنند، مگر اینکه نقشی دقیق و مشخص در آن داشته باشند (مثلاً مسئول فنی یا مستندساز باشند).
                            </p>
                        </div>

                        <div>
                            <h4 className="font-semibold mb-2">۵. علاقه‌مند به برنامه‌ریزی برای تفریح</h4>
                            <p>
                                بله! High C حتی برای سفر تفریحی، برنامه‌ریزی، چک‌لیست، تحقیق در مورد مقصد، مسیر و بودجه تهیه می‌کند. تفریح بدون برنامه برای او استرس‌زاست.
                            </p>
                        </div>
                    </div>

                </div>
            </Page>

            <Page
                testResult={testResult}
                title=""
            >
                <div className="text-gray-800 space-y-4">

                    <div>
                        <h4 className="font-semibold mb-2">۶. لذت از یادگیری حتی در اوقات فراغت</h4>
                        <p>
                            دیدن مستند علمی، دوره آنلاین، تحلیل فیلم یا تحقیق درباره موضوعات مورد علاقه (مثلاً فناوری، تاریخ، روان‌شناسی تحلیلی) بخشی از اوقات فراغت دلخواه‌شان است.
                        </p>
                        <p>
                            <strong>مثال:</strong> فرد High C ممکن است در روز تعطیل، لپ‌تاپش را باز کند، فایل‌های شخصی‌اش را دسته‌بندی کند، یا با علاقه مشغول ویرایش دقیق یک مقاله یا طراحی مالی شخصی‌اش شود. همه این‌ها برایش آرامش‌بخش است.
                        </p>
                    </div>

                    <div className="mt-4">
                        <p>
                            <strong>فیلم پیشنهادی:</strong> <em>The Theory of Everything</em> (نظریه همه چیز)، داستان استیون هاوکینگ که دنیای ذهنی، تحلیل علمی و سکوت درونی‌اش، تصویری دقیق از تفریح فکری و درون‌گرایانه یک High C را نشان می‌دهد.
                        </p>
                    </div>
                </div>
            </Page>

            <Page
                testResult={testResult}
                title="تصمیم‌گیری در تیپ High C"
            >
                <div className="text-gray-800 leading-7 space-y-4">
                    <p>
                        برای افراد با تیپ High C، تصمیم‌گیری نه یک واکنش، بلکه یک فرآیند تحلیلی است. آن‌ها قبل از هر تصمیم، نیاز به داده، منطق، مستندات و قطعیت دارند. تصمیم‌گیری برایشان نوعی «تعهد به دقت» است، نه فقط «اقدام برای نتیجه».
                    </p>

                    <div className="space-y-4">
                        <div>
                            <h4 className="font-semibold mb-2">۱. تصمیم‌گیری فقط بعد از جمع‌آوری اطلاعات کافی</h4>
                            <p>
                                High C تا زمانی که همه جوانب را بررسی نکند، وارد فاز تصمیم‌گیری نمی‌شود. او سؤال می‌پرسد، منابع را چک می‌کند، ریسک‌ها را می‌سنجد و تازه بعد از اطمینان نسبی وارد مرحله اقدام می‌شود.
                            </p>
                            <p><strong>جمله طلایی یک High C:</strong> «اجازه بده اول همه گزینه‌ها رو ببینم، بعد حرف بزنیم.»</p>
                        </div>

                        <div>
                            <h4 className="font-semibold mb-2">۲. پرهیز از تصمیمات سریع، احساسی یا بدون شواهد</h4>
                            <p>
                                در موقعیت‌های اضطراری یا هیجانی، ممکن است دچار قفل رفتاری شود یا از تصمیم‌گیری طفره برود. چون برایش مهم است «درست تصمیم بگیرد» نه فقط «تصمیم بگیرد».
                            </p>
                        </div>

                        <div>
                            <h4 className="font-semibold mb-2">۳. نگاه منطقی، نه شهودی یا جمع‌محور</h4>
                            <p>
                                او برخلاف تیپ I که تحت تأثیر جمع است یا تیپ D که شهودی تصمیم می‌گیرد، به عدد، قانون، تجربه و تحلیل رجوع می‌کند. به‌همین دلیل گاهی به نظر کند، خشک یا حتی شکاک می‌رسد.
                            </p>
                        </div>

                        <div>
                            <h4 className="font-semibold mb-2">۴. ترس از اشتباه، یکی از موانع اصلی تصمیم‌گیری</h4>
                            <p>
                                High C معمولاً از اشتباه‌کردن می‌ترسد چون برایش نشانه‌ای از بی‌دقتی یا ناکارآمدی است. این ترس می‌تواند باعث شود تصمیم‌گیری را بیش از حد به تعویق بیندازد یا تصمیم نهایی را به دیگران واگذار کند.
                            </p>
                        </div>

                        <div>
                            <h4 className="font-semibold mb-2">۵. در تصمیم‌گیری‌های گروهی، نقش «هشداردهنده عواقب»</h4>
                            <p>
                                او کسی است که می‌پرسد: «اگر این تصمیم اشتباه باشه، چی؟» یا «آیا تا حالا مشابهش رو آزمایش کردیم؟» این ویژگی بسیار ارزشمند است، البته اگر با احترام مدیریت شود.
                            </p>
                        </div>

                        <div>
                            <h4 className="font-semibold mb-2">۶. نیازمند اجازه و اختیار برای تصمیم‌گیری</h4>
                            <p>
                                High C اگر بداند حوزه تصمیم‌گیری‌اش مشخص است و آزادی در چارچوب دارد، بسیار بهتر عمل می‌کند. اما اگر فضا مبهم یا اقتدارش مخدوش باشد، ممکن است کناره‌گیری کند.
                            </p>
                        </div>

                    </div>
                </div>
            </Page>

            <Page
                testResult={testResult}
                title=""
            >
                <div className="text-gray-800 space-y-4">
                    <div>
                        <h4 className="font-semibold mb-2">پیشنهاداتی برای تصمیم‌گیری بهتر:</h4>
                        <ul className="list-disc list-inside space-y-1">
                            <li>زمان مشخصی برای «اقدام نهایی» تعیین کنید تا در تحلیل بی‌پایان گیر نکند.</li>
                            <li>از تیپ‌های D یا S کمک بگیرید تا تصویر کلی یا تجربه‌های مشابه را وارد تحلیل کنید.</li>
                            <li>با پذیرش اینکه «هیچ تصمیمی بدون ریسک نیست»، جسارت اجرا را تمرین کنید.</li>
                            <li>از مدل‌های تصمیم‌سازی مثل ماتریس SWOT یا نمودار هزینه-فایده استفاده کنید.</li>
                        </ul>
                    </div>

                    <div>
                        <h4 className="font-semibold mb-2">مثال کاربردی:</h4>
                        <p>
                            در جلسه‌ای که نیاز به انتخاب یکی از دو تأمین‌کننده هست، High C ابتدا جدول مقایسه‌ای می‌سازد، نظرات فنی تیم را جمع‌آوری می‌کند، سوابق هر تأمین‌کننده را بررسی می‌کند، و فقط وقتی اطمینان یافت، انتخاب می‌کند، حتی اگر این فرآیند چند روز طول بکشد.
                        </p>
                    </div>
                    <div className="mt-4">
                        <p>
                            <strong>فیلم پیشنهادی:</strong> <em>Eye in the Sky</em> (نگاه آسمانی)، شخصیت آلن ریکمن در مواجهه با تصمیمات نظامی دقیق، بین اخلاق، تحلیل و سیاست، نشان می‌دهد چطور یک تصمیم می‌تواند بدون شتاب ولی با دقت بالا اتخاذ شود.
                        </p>
                    </div>
                </div>
            </Page>

            <Page
                testResult={testResult}
                title="پیشنهادات جهت بهبود عملکرد High C"
            >
                <div className="text-gray-800 space-y-4">
                    <p>
                        (از کمال‌گرایی فلج‌کننده، به اقدام مؤثر و تعادل‌محور)
                        High Cها به‌طور طبیعی ظرفیت بالایی برای انجام کارهای دقیق، منظم و قابل اتکا دارند. اما همین ویژگی‌ها اگر مدیریت نشوند، ممکن است به تأخیر، شک، محافظه‌کاری بیش از حد و ناکارآمدی منجر شود. در این بخش، راهکارهایی عملی برای ارتقاء عملکرد این تیپ ارائه می‌شود.
                    </p>

                    <div className="space-y-4">
                        <div>
                            <h4 className="font-semibold mb-2">۱. کمال‌گرایی را به کیفیت قابل قبول تبدیل کنید</h4>
                            <p>
                                <strong>شعار طلایی:</strong> Done is better than perfect
                                یعنی «انجام‌شده» بهتر از «کامل ولی ناتمام» است. تلاش برای بی‌نقص بودن، گاهی مانع شروع یا اتمام کار می‌شود.
                            </p>
                        </div>

                        <div>
                            <h4 className="font-semibold mb-2">۲. سرعت تصمیم‌گیری را با تعریف چارچوب افزایش دهید</h4>
                            <p>
                                به جای تحلیل بی‌پایان، از مدل‌های تصمیم‌سازی کمک بگیرید:
                            </p>
                            <ul className="list-disc list-inside space-y-1">
                                <li>معیارهای ثابت برای اولویت‌بندی کارها</li>
                                <li>تعیین «حداکثر زمان مجاز برای بررسی»</li>
                                <li>مشورت با تیپ‌های سریع‌تر مثل High D یا I برای تکمیل تحلیل</li>
                            </ul>
                        </div>

                        <div>
                            <h4 className="font-semibold mb-2">۳. انعطاف را تمرین کنید</h4>
                            <p>
                                یاد بگیرید که «همه‌چیز طبق نقشه پیش نمی‌رود» و شما هم لازم نیست همیشه کنترل کامل داشته باشید. گاهی «پیشرفت» از «پیش‌بینی» مهم‌تر است.
                            </p>
                        </div>

                        <div>
                            <h4 className="font-semibold mb-2">۴. یاد بگیرید اشتباه کردن، بخشی از رشد است</h4>
                            <p>
                                High C معمولاً از اشتباه وحشت دارد. اما اگر اشتباهات را به‌عنوان بخشی از فرایند یادگیری ببینید، راحت‌تر دست به تجربه‌های جدید می‌زنید.
                            </p>
                        </div>

                        <div>
                            <h4 className="font-semibold mb-2">۵. ارتباط‌گراتر شوید؛ از لاک تحلیل بیرون بیایید</h4>
                            <p>
                                سعی کنید در جلسات تیمی بیشتر صحبت کنید، حتی اگر حرف‌تان آماده نباشد. با گوش دادن فعال و بازخورد‌دادن به دیگران، مسیر تعادل را تمرین کنید.
                            </p>
                        </div>
                    </div>
                </div>
            </Page>

            <Page
                testResult={testResult}
                title=""
            >
                <div className="text-gray-800 space-y-4">
                    <div>
                        <h4 className="font-semibold mb-2">۶. کنترل بر همه‌چیز لازم نیست</h4>
                        <p>
                            در کار گروهی، گاهی بخشی از کار را به دیگران بسپارید، حتی اگر فکر می‌کنید خودتان بهتر انجام می‌دهید. تفویض کار = توسعه عملکرد.
                        </p>
                    </div>

                    <div>
                        <h4 className="font-semibold mb-2">۷. نسبت به احساسات دیگران حساس‌تر باشید</h4>
                        <p>
                            نه از روی هیجان، بلکه از روی همدلی منطقی. سعی کنید تأثیر رفتارتان بر دیگران را ببینید. گاهی یک جمله‌تان ممکن است ناخواسته سرد یا قضاوت‌گرانه باشد.
                        </p>
                    </div>

                    <div>
                        <h4 className="font-semibold mb-2">۸. از ابزارهای تعادل استفاده کنید</h4>
                        <ul className="list-disc list-inside space-y-1">
                            <li>تایمر برای محدود کردن زمان تحلیل</li>
                            <li>جدول «اقدام فوری / اقدام غیر فوری»</li>
                            <li>تکنیک Pomodoro برای حفظ تمرکز و عمل‌گرایی</li>
                            <li>ژورنال هفتگی برای ثبت اشتباهات و بینش‌ها</li>
                        </ul>
                    </div>

                    <div>
                        <h4 className="font-semibold mb-2">مثال کاربردی</h4>
                        <p>
                            فردی با تیپ High C که همیشه گزارش‌های مالی را با وسواس تهیه می‌کرد، یاد گرفت فقط ۸۰٪ گزارش را به دقت کامل برساند، سپس آن را به همکارش تحویل دهد برای ویرایش نهایی. این روش باعث شد بهره‌وری‌اش دو برابر شود و فشار روانی‌اش کاهش یابد.
                        </p>
                    </div>

                    <div>
                        <h4 className="font-semibold mb-2">فیلم پیشنهادی</h4>
                        <p>
                            <em>Hidden Figures</em> (ارقام پنهان)، شخصیت «کاترین جانسون» (ریاضی‌دان ناسا) نمونه‌ای از High C با دقت و کمال‌گرایی بالا است که یاد می‌گیرد در کنار تحلیل، تصمیم‌گیری و اقدام در زمان محدود را نیز تقویت کند.
                        </p>
                    </div>
                </div>
            </Page>

            <Page
                testResult={testResult}
                title="رمز موفقیت در تیپ High C"
            >
                <div className="text-gray-800 space-y-4">
                    <p className='text-center -mt-6'>(تعادلی از دقت، اقدام و تعامل)</p>
                    <p>
                        افراد High C به طور طبیعی پایه‌های محکمی برای موفقیت دارند: تفکر عمیق، دقت بالا، مسئولیت‌پذیری، و تعهد به استانداردها. اما این ظرفیت بالقوه، تنها زمانی بالفعل می‌شود که آن‌ها از دام وسواس، تحلیل بیش از حد، و انزوا رها شوند. رمز موفقیت برای تیپ C، در یادگیری «تعادل» است.
                    </p>

                    <div className="space-y-4">
                        <div>
                            <h4 className="font-semibold mb-1">۱. اقدام پیش از اطمینان کامل</h4>
                            <p>
                                موفقیت از دل عمل می‌آید، نه فقط تحلیل.
                                به‌جای صبر برای کامل شدن شرایط، با ۷۰٪ اطلاعات دست به کار شوید و اجازه دهید مسیر، بخش باقی‌مانده را روشن کند.
                            </p>
                        </div>

                        <div>
                            <h4 className="font-semibold mb-1">۲. تمرین رها کردن کنترل</h4>
                            <p>
                                یاد بگیرید همه‌چیز لازم نیست تحت کنترل کامل شما باشد. گاهی دیگران هم می‌توانند خوب عمل کنند، حتی اگر به روش شما نباشد.
                            </p>
                        </div>

                        <div>
                            <h4 className="font-semibold mb-1">۳. ارتباط مؤثر با دیگران</h4>
                            <p>
                                برقراری ارتباط، بخشی از موفقیت است. اگر فقط روی محتوا تمرکز کنید و از زبان بدن، لحن، و شنیدن فعال غافل شوید، پیام‌تان نیمه‌کاره می‌ماند.
                            </p>
                        </div>

                        <div>
                            <h4 className="font-semibold mb-1">۴. پذیرش اشتباه = شروع یادگیری</h4>
                            <p>
                                High C موفق کسی است که اشتباهات را بپذیرد، از آن‌ها بیاموزد و به‌جای خودانتقادی افراطی، بینش استخراج کند.
                            </p>
                        </div>

                        <div>
                            <h4 className="font-semibold mb-1">۵. حرکت از کمال‌گرایی به کیفیت متوازن</h4>
                            <p>
                                کمال‌گرایی فلج‌کننده را کنار بگذارید و کیفیت عملی را جایگزین کنید:
                                «دقیق، اما قابل تحویل» بهتر از «بی‌نقص، ولی ناقص» است.
                            </p>
                        </div>

                        <div>
                            <h4 className="font-semibold mb-1">۶. تمرین سرعت، بدون ترک دقت</h4>
                            <p>
                                با ابزارهایی مثل محدودیت زمانی، کار تیمی، یا پاسخ‌گویی سریع در جلسات، مهارت تصمیم‌گیری و اقدام به‌موقع را افزایش دهید.
                            </p>
                        </div>

                        <div>
                            <h4 className="font-semibold mb-1">۷. اعتماد به خود، نه فقط به سیستم</h4>
                            <p>
                                سیستم و چارچوب عالی‌اند، ولی گاهی به شهود و تجربه خود هم گوش بدهید. اعتماد به نفس شما مکمل خوبی برای دقت‌تان خواهد بود.
                            </p>
                        </div>
                    </div>
                </div>
            </Page>

            <Page
                testResult={testResult}
                title="خلاصه رمزهای موفقیت High C"
            >
                <div className="text-gray-800 space-y-4">
                    <ul className="list-disc list-inside space-y-1">
                        <li>اقدام در زمان مناسب</li>
                        <li>کاهش وابستگی به قطعیت کامل</li>
                        <li>افزایش تعامل و انعطاف</li>
                        <li>اعتماد به تجربه + تحلیل</li>
                        <li>پذیرش «خوب بودن کافی‌ست»</li>
                        <li>یادگیری از بازخوردها و اشتباهات</li>
                        <li>تبدیل محتاط بودن به قدرت پیش‌بینی</li>
                    </ul>
                    <p className="mt-2">
                        <strong>پیشنهاد فیلم: </strong>
                        <em>The Intern</em>، شخصیت رابرت دنیرو (بن)، با رفتار دقیق، آرام، متعهد و تحلیلی‌اش، زمانی به موفقیت می‌رسد که یاد می‌گیرد در کنار چارچوب، مهربانی، انعطاف و تعامل انسانی هم داشته باشد.
                    </p>
                </div>
            </Page>

            <Page
                testResult={testResult}
                title="نحوه تعدیل و تقویت سایر لایه‌ها در تیپ High C"
            >
                <div className="text-gray-800 space-y-4">
                    <p>
                        برای افراد <strong>High C</strong>، داشتن دقت، تحلیل و ساختار یک مزیت است؛ اما وقتی این ویژگی‌ها با ویژگی‌های مثبت سایر تیپ‌ها ترکیب شود، خروجی بهینه‌تری حاصل می‌گردد. در این بخش، به روش‌های تعدیل و تقویت سه لایه دیگر در تیپ شخصیتی C می‌پردازیم:
                    </p>

                    <ol className="list-decimal list-inside space-y-2">
                        <li>
                            <strong>تقویت لایه D – تسلط و قاطعیت</strong>
                            <p>چه چیزی باید تقویت شود؟ تصمیم‌گیری سریع‌تر، جسارت در شروع کارها، تمرکز بر نتیجه، نه فقط روش</p>
                            <p>چگونه؟</p>
                            <ul className="list-disc list-inside space-y-1">
                                <li>از عبارت‌هایی مانند «مهم اقدامه، نه فقط تحلیل» بیشتر استفاده کنید.</li>
                                <li>با تیپ‌های D معاشرت شغلی یا مربی‌گری داشته باشید.</li>
                                <li>پروژه‌هایی بپذیرید که نتیجه‌محور و زمان‌دار باشند.</li>
                                <li>کتاب یا فیلم‌هایی درباره رهبری و جسارت ببینید؛ مثلاً <em>Lincoln</em>.</li>
                            </ul>
                        </li>

                        <li>
                            <strong>تقویت لایه I – تأثیرگذاری و ارتباط‌پذیری</strong>
                            <p>چه چیزی باید تقویت شود؟ مهارت‌های بین‌فردی، بیان احساسات و بازخورد دادن، سبک ارتباط گرم‌تر و خودافشایی</p>
                            <p>چگونه؟</p>
                            <ul className="list-disc list-inside space-y-1">
                                <li>از کلمات شاد، مثبت و هیجانی در جلسات استفاده کنید (مثلاً: «خوشحال می‌شم»، «خیلی جالبه»، «لذت بردم»).</li>
                                <li>در جلسات گروهی، قبل از تحلیل، احوال‌پرسی یا شوخی کوچکی داشته باشید.</li>
                                <li>در کار تیمی، از افراد بخواهید بازخورد شخصی و احساسی بدهند.</li>
                            </ul>
                            <p><strong>فیلم پیشنهادی:</strong> <em>The Pursuit of Happyness</em> (در جستجوی خوشبختی) برای تقویت تأثیرگذاری انسانی.</p>
                        </li>

                        <li>
                            <strong>تقویت لایه S – ثبات، همدلی و صبوری</strong>
                            <p>چه چیزی باید تقویت شود؟ توجه به احساسات و نیازهای دیگران، صبوری در برابر کندی یا اشتباهات دیگران، حمایت هیجانی، نه فقط فنی</p>
                            <p>چگونه؟</p>
                            <ul className="list-disc list-inside space-y-1">
                                <li>قبل از اصلاح کسی، از او بپرسید آیا تمایل دارد بازخورد بشنود؟</li>
                                <li>هنگام ناراحتی یا اشتباه دیگران، به‌جای تحلیل، ابتدا همدلی نشان دهید.</li>
                                <li>به جملاتی مثل «اشکالی نداره، همه اشتباه می‌کنن» یا «می‌دونم تحت فشاری» عادت کنید.</li>
                            </ul>
                            <p><strong>فیلم پیشنهادی:</strong> <em>The King's Speech</em> (سخنرانی پادشاه) ترکیبی از حمایت، صبر، و قدرت انسانی.</p>
                        </li>
                    </ol>
                </div>
            </Page>

            <Page
                testResult={testResult}
                title="جملات و کلمات کلیدی برای تعدیل High C"
            >
                <div className="text-gray-800 space-y-4">
                    <ul className="list-disc list-inside space-y-2">
                        <li>«همیشه نباید همه‌چیز کامل باشه.»</li>
                        <li>«مهم اقدامه، بعدش می‌تونیم اصلاح کنیم.»</li>
                        <li>«می‌خوام اول حس طرف مقابل رو درک کنم.»</li>
                        <li>«مهم نیست کی اشتباه کرد، مهم اینه درستش کنیم.»</li>
                        <li>«گاهی لازمه به حس و تجربه هم اعتماد کنیم.»</li>
                    </ul>

                    <p className="mt-4">
                        با این تمرینات رفتاری، فرد  High C می‌تواند به نسخه‌ای بالغانه‌تر از خودش برسد؛ ترکیبی از دقت و منطق با قاطعیت، صمیمیت و پایداری.
                    </p>
                </div>
            </Page>

            <Page
                testResult={testResult}
                title="دانش و مهارت‌های مورد نیاز الگوی High C"
            >
                <div className="text-gray-800 space-y-4">
                    <p>(از دقت انفرادی تا اثربخشی تیمی)</p>
                    <p>
                        افراد <strong>High C</strong> اگرچه در حوزه‌های فنی و تحلیلی عملکرد بسیار بالایی دارند، اما برای موفقیت پایدار در محیط‌های کاری و اجتماعی امروزی، نیازمند توسعه مهارت‌هایی هستند که به آن‌ها در کاهش وسواس، افزایش تعاملات انسانی و اقدام مؤثر کمک کند. در ادامه، مجموعه‌ای از مهم‌ترین مهارت‌های مورد نیاز این افراد آمده است:
                    </p>

                    <ul className="list-decimal list-inside space-y-2">
                        <li>
                            <strong>مهارت تصمیم‌گیری سریع و منطقی</strong><br />
                            استفاده از مدل‌های تصمیم‌گیری، اولویت‌بندی اطلاعات حیاتی، تمرین «خطر منطقی» برای عبور از تحلیل فلج‌کننده
                        </li>
                        <li>
                            <strong>مهارت ارتباطات بین‌فردی و گفت‌وگو</strong><br />
                            یادگیری بازخورد مؤثر و همدلانه، توسعه مهارت گوش دادن فعال، تمرین بیان احساسات و نیازها
                        </li>
                        <li>
                            <strong>هوش هیجانی</strong><br />
                            تشخیص و مدیریت هیجانات خود، همدلی با دیگران بدون قضاوت، کنترل کمال‌گرایی از طریق پذیرش خطا
                        </li>
                        <li>
                            <strong>هنر تفویض اختیار و کار تیمی</strong><br />
                            اعتماد به دیگران برای تحویل کار، استفاده از مهارت‌های تیم، تعریف مرز بین «کیفیت شخصی» و «هدف گروهی»
                        </li>
                        <li>
                            <strong>مهارت مدیریت زمان و تمرکز</strong><br />
                            استفاده از تکنیک‌هایی مثل Pomodoro، تبدیل چک‌لیست‌ها به اقدام اولویت‌دار، تنظیم زمان «شروع» به جای «اتمام بی‌نقص»
                        </li>
                        <li>
                            <strong>هنر نه گفتن و تعیین مرز</strong><br />
                            مدیریت درخواست‌های وقت‌گیر دیگران، شناخت تفاوت بین مسئولیت‌پذیری و کنترل‌گری، نه گفتن محترمانه اما قاطع
                        </li>
                        <li>
                            <strong>مهارت ارائه و سخنرانی اثربخش</strong><br />
                            ساده‌سازی مطالب پیچیده، استفاده از داستان برای انتقال پیام، کنترل لحن خشک یا رسمی در گفتار
                        </li>
                        <li>
                            <strong>مهارت پذیرش بازخورد و مدیریت خطا</strong><br />
                            تمرین پذیرش نقد بدون فروپاشی ذهنی، بازبینی عملکرد بدون خودسرزنش‌گری، نگاه یادگیرنده به شکست‌ها
                        </li>
                    </ul>
                </div>
            </Page>

            <Page
                testResult={testResult}
                title=""
            >
                <div className="text-gray-800 space-y-4">
                    <ul>
                        <li>
                            <strong>خلاقیت و ریسک‌پذیری سازنده</strong><br />
                            کشف راه‌حل‌های نو در چارچوب مشخص، استفاده از تکنیک‌های خلاقیت مثل SCAMPER، پروژه‌های آزمایشی با کنترل محدود
                        </li>

                        <li>
                            <strong>هوش مالی و تحلیل اقتصادی فردی</strong><br />
                            طراحی سیستم‌های مالی شخصی، بودجه‌بندی منطقی، ارزیابی هزینه-فایده در تصمیمات خرید یا سرمایه‌گذاری
                        </li>
                    </ul>

                    <p>
                        <strong>جمع‌بندی:</strong><br />
                        افراد <strong>High C</strong> به‌واسطه ساختار ذهنی دقیق خود، به‌راحتی می‌توانند در فضای تخصصی بدرخشند. اما برای پیشرفت متوازن، باید مهارت‌هایی را بیاموزند که از «دقت انفرادی» به سمت «اثرگذاری گروهی» حرکت‌شان دهد.
                    </p>

                    <p>
                        <strong>مثال فیلم:</strong><br />
                        <em>The Social Network</em> (شبکه اجتماعی)، شخصیت مارک زاکربرگ با ترکیب تیپ C و D، با وجود دقت و ذهن فنی قوی، وقتی یاد می‌گیرد ارتباطات، احساسات و ارائه را هم تقویت کند، موفقیتش چندبرابر می‌شود.
                    </p>
                </div>
            </Page>

            <Page
                testResult={testResult}
                title="مشاغل مناسب برای افراد با الگوی High C"
            >
                <div className="text-gray-800 space-y-4">
                    <p>(دقیق، تحلیلی، ساختارمند و متعهد به کیفیت)</p>
                    <p>
                        افراد <strong>High C</strong> در محیط‌هایی که نیاز به نظم، دقت، تحلیل، مستندسازی و رعایت قوانین دارد، عملکردی درخشان از خود نشان می‌دهند. این افراد به دلیل رویکرد سیستمی و علاقه به استانداردها، اغلب در مشاغل فنی، تحلیلی، پژوهشی و نظارتی بسیار موفق هستند. البته لازم است رغبت‌های شغلی (هالند)، توانمندی‌ها و شرایط بازار نیز در انتخاب شغل لحاظ شود.
                    </p>

                    <ul className="space-y-4">
                        <li>
                            <strong>حسابدار / حسابرس</strong><br />
                            مناسب برای افرادی که به نظم عددی، دقت بالا و بررسی‌های جزئی علاقه دارند. مستندسازی و رعایت استانداردهای مالی نقطه قوت آن‌هاست.
                        </li>
                        <li>
                            <strong>تحلیل‌گر داده / تحلیل‌گر سیستم‌ها</strong><br />
                            در این شغل، <strong>High C</strong> می‌تواند با بررسی داده‌های خام، الگوها را کشف کرده و برای بهینه‌سازی تصمیم‌گیری سازمانی اقدام کند.
                        </li>
                        <li>
                            <strong>برنامه‌نویس یا توسعه‌دهنده نرم‌افزار</strong><br />
                            کدنویسی دقیق، تست مداوم، و رفع خطا نیازمند ویژگی‌های شخصیتی این تیپ است.
                        </li>
                        <li>
                            <strong>پژوهشگر / محقق دانشگاهی</strong><br />
                            تحقیق، مطالعه، مستندسازی و ارائه علمی با دقت بالا کاملاً با شخصیت <strong>High C</strong> سازگار است.
                        </li>
                        <li>
                            <strong>مهندس کنترل کیفیت / تضمین کیفیت (QA)</strong><br />
                            بررسی استانداردها، اجرای تست، ارزیابی انحراف‌ها و ارائه راه‌حل، حوزه‌ای است که دقت بالا در آن ضروری است.
                        </li>
                        <li>
                            <strong>وکیل / مشاور حقوقی</strong><br />
                            در این حوزه‌ها نیاز به تسلط بر قانون، بررسی مدارک، و دفاع مستدل و مستند است. <strong>High C</strong>ها اگر جسارت ابراز را تقویت کنند، در این شغل بسیار موفق‌اند.
                        </li>
                        <li>
                            <strong>طراح صنعتی یا مهندس مکانیک دقیق</strong><br />
                            طراحی اجزا، تحلیل عملکرد، تست محصول و مستندسازی مراحل فنی، از وظایف مطلوب این تیپ است.
                        </li>
                        <li>
                            <strong>معمار سیستم‌های IT یا شبکه</strong><br />
                            برنامه‌ریزی دقیق، طراحی منطقی و رعایت اصول ساختاری، شایستگی‌های متناسب <strong>High C</strong>هاست.
                        </li>

                    </ul>
                </div>
            </Page>

            <Page
                testResult={testResult}
                title=""
            >
                <div className="text-gray-800 space-y-4">
                    <ul className='space-y-4'>
                        <li>
                            <strong>ویراستار علمی / نویسنده فنی</strong><br />
                            برای کسانی که علاقه به نوشتار ساختارمند، منطقی، دقیق و با قواعد زبانی کامل دارند.
                        </li>
                        <li>
                            <strong>متخصص کنترل پروژه</strong><br />
                            زمان‌بندی، مدیریت منابع، تحلیل ریسک و تهیه گزارش‌های پیشرفت، حوزه‌ای است که هم‌زمان به دقت و ساختار نیاز دارد.
                        </li>
                        <li>
                            <strong>افسر امنیت اطلاعات یا کارشناس انطباق (Compliance Officer)</strong><br />
                            کنترل، نظارت، بررسی قوانین و رعایت خط‌مشی‌ها، از اصلی‌ترین نیازهای این شغل است.
                        </li>
                        <li>
                            <strong>آزمایشگر / متخصص آزمایشگاه‌های تخصصی</strong><br />
                            از کارهای دقیق، تکرارشونده، و استاندارد که نیاز به نظم و ثبت مستندات دارد، استقبال می‌کنند.
                        </li>
                    </ul>

                    <p>
                        <strong>نکته تکمیلی:</strong><br />
                        <strong>High C</strong>ها باید حواس‌شان باشد که در مشاغلی با فشار هیجانی بالا، روابط مبهم یا سرعت عمل زیاد، ممکن است دچار فرسودگی یا اضطراب شوند. برای آن‌ها مهم است که در محیطی باشند که شفاف، مستند، منظم و قابل پیش‌بینی باشد.
                    </p>

                    <p>
                        <strong>فیلم الهام‌بخش:</strong><br />
                        <em>The Accountant</em>، تصویری از یک فرد با تیپ C بالا که با دقت، تحلیل و رویکرد ساختارمند به حل مسائل مالی و امنیتی می‌پردازد. (البته با زمینه داستانی مهیج)
                    </p>
                </div>
            </Page>

            <Page
                testResult={testResult}
                title="همسر مناسب و نحوه ارتباط مؤثر با او"
            >
                <div className="text-gray-800 space-y-4">
                    افراد با الگوی رفتاری  High C در روابط عاطفی و زناشویی به دنبال ثبات، منطق، پیش‌بینی‌پذیری و احترام متقابل هستند. آن‌ها به راحتی احساسات‌شان را بروز نمی‌دهند، اما اگر احساس امنیت کنند، به‌شدت وفادار و متعهد خواهند بود.

                </div>
            </Page>

            <Page
                testResult={testResult}
                title="ویژگی‌های شخصیتی مناسب همسر فرد High C"
            >
                <div className="text-gray-800 space-y-4">
                    فردی صبور و قابل‌اعتماد
                    کسی که اهل اغراق، درام یا هیجان‌های غیرمنطقی نباشد
                    توانایی گفت‌وگوی آرام، بدون حمله یا سرزنش
                    اهل نظم، احترام به حریم شخصی و ساختار
                    کسی که به احساسات درونی  High C توجه کند حتی اگر به زبان نیاید

                </div>
            </Page>

            <Page
                testResult={testResult}
                title="نکاتی که همسر فرد High C باید بداند"
            >
                <div className="text-gray-800 space-y-4">
                    واکنش کم، به معنی بی‌احساسی نیست.
                    High C  ممکن است محبت را از طریق کارهای دقیق و تعهد نشان دهد، نه کلمات عاشقانه یا نمایش‌های هیجانی.
                    نقد را شخصی نکنید. اگر چیزی را اصلاح یا دقیق بیان می‌کند، اغلب از سر دقت است، نه کنترل یا بی‌احترامی.
                    خلوت او را محترم بشمارید. گاهی به تنهایی یا سکوت نیاز دارد تا ذهنش را سامان دهد.
                    سوال بپرسید، نه اینکه احساسات را به او تحمیل کنید. بپرسید "چه چیزی ناراحتت کرده؟" نه اینکه بگویید "تو همیشه سردی!"
                    قدردانی صریح داشته باشید. اگر کاری را با دقت و وسواس برای خانه یا خانواده انجام داد، از او تشکر کنید.
                </div>
            </Page>

            <Page
                testResult={testResult}
                title="نکاتی که فرد باید در زندگی زناشویی رعایت کند"
            >
                <div className="text-gray-800 space-y-4">
                    <ul className="list-disc list-inside space-y-2">
                        <li>احساساتت را بیشتر بروز بده. منتظر نمان که فقط در کار خوب دیده شوی.</li>
                        <li>به احساسات طرف مقابل گوش بده، حتی اگر منطقی نیست.</li>
                        <li>درگیر جزئیات نشو، اصل رابطه را ببین.</li>
                        <li>گاهی بگذار همه‌چیز کامل نباشد. تجربه‌های ساده و صمیمانه مهم‌تر از برنامه کامل است.</li>
                        <li>زمان مشخصی را برای گفت‌وگوهای غیرکاری بگذار.</li>
                    </ul>

                    <div className="mt-4">
                        <h4 className="font-semibold text-gray-800 mb-2">فیلم پیشنهادی:</h4>
                        <p>
                            A Beautiful Mind ذهن زیبا، رابطه جان نش با تیپ  High Cبا همسرش که با صبوری، همدلی و حفظ چارچوب، پایه‌گذار یکی از زیباترین روابط زندگی واقعی است.
                        </p>
                    </div>
                </div>
            </Page>

            <Page
                testResult={testResult}
                title="ارتباط مؤثر والدین High C با فرزندان و بالعکس"
            >
                <div className="text-gray-800 space-y-4">
                    والدین  High C به‌طور طبیعی منظم، مسئولیت‌پذیر و متعهدند. آن‌ها دوست دارند فرزندان‌شان درست، باقاعده و مستقل رشد کنند. اما اگر به احساسات، انعطاف‌پذیری و بازیگوشی کودکان توجه نکنند، ممکن است فاصله‌ای عاطفی شکل بگیرد.

                </div>
            </Page>

            <Page
                testResult={testResult}
                title="ارتباط مؤثر High C با فرزندان"
            >
                <div className="text-gray-800 space-y-4">
                    <p><strong>کاهش سخت‌گیری افراطی:</strong><br />
                        فرزندان همیشه نمی‌توانند مطابق استاندارد ذهنی شما عمل کنند. به‌جای تمرکز بر نقص‌ها، دستاوردهای کوچک را تشویق کنید.
                    </p>

                    <p><strong>بیان محبت کلامی و غیرکلامی:</strong><br />
                        صرفاً با انجام وظایف پدر/مادری نمی‌توان رابطه‌ای گرم ساخت. در آغوش گرفتن، لبخند، شوخی و گفتن جملاتی مثل "بهت افتخار می‌کنم" بسیار اثرگذار است.
                    </p>

                    <p><strong>گوش دادن فعال:</strong><br />
                        وقتی فرزندتان حرف می‌زند، او را قطع نکنید، اصلاح نکنید و قضاوت نکنید. فقط گوش کنید.
                    </p>

                    <p><strong>اجازه دهید اشتباه کنند:</strong><br />
                        فرزندتان باید اشتباه کند تا یاد بگیرد. هر خطایی نیاز به مداخله فوری ندارد؛ گاهی فقط مشاهده و حمایت کافی است.
                    </p>

                    <p><strong>زمان بدون ساختار:</strong><br />
                        در کنار برنامه‌ریزی، زمانی را صرف وقت‌گذرانی آزاد و بی‌هدف با فرزندتان بکنید. بازی کنید، بخندید و صرفاً "حضور" داشته باشید.
                    </p>
                </div>
            </Page>

            <Page
                testResult={testResult}
                title="فرزندان یک والد High C چگونه رفتار کنند"
            >
                <div className="text-gray-800 space-y-4">
                    صداقت و شفافیت داشته باشید. والدین  High C از پنهان‌کاری بیزارند.
                    به قوانین و چارچوب‌ها احترام بگذارید. این باعث اعتماد بیشتر می‌شود.
                    در موقع مناسب، احساسات‌تان را بیان کنید. به آن‌ها بگویید که گاهی سخت‌گیری‌شان شما را خسته می‌کند، اما دوست‌شان دارید.
                    از رفتار دقیق و منظم آن‌ها الگو بگیرید.
                    در زمان عصبانیت یا فشار، سکوت آن‌ها را به منزله بی‌محبتی ندانید. آن‌ها فقط نیاز به پردازش دارند.
                </div>
            </Page>


            <Page
                testResult={testResult}
                title="چگونه با والد High C ارتباط مؤثر برقرار کنیم؟"
            >
                <div className="text-gray-800 space-y-4">
                    <p><strong>آرام و منطقی صحبت کنید:</strong><br />
                        اغراق، درام یا هیجان زیاد ممکن است باعث شود والد High C ارتباط را ببندد.</p>

                    <p><strong>سند، دلیل یا نمونه بیاورید:</strong><br />
                        آن‌ها با داده و منطق راحت‌تر قانع می‌شوند.</p>

                    <p><strong>از رفتارشان تشکر کنید:</strong><br />
                        مثلاً بگویید: "می‌دونم خیلی زحمت می‌کشی که همه‌چیز منظم باشه، واقعاً ممنونم."</p>

                    <p><strong>در تصمیم‌گیری‌های مهم نظرشان را بپرسید:</strong><br />
                        این حس ارزشمندی و مشارکت را در آن‌ها تقویت می‌کند.</p>

                    <p><strong>از سرزنش یا شوخی بی‌جا بپرهیزید:</strong><br />
                        High Cها ممکن است آن را حمله تلقی کنند.</p>

                    <p><strong>صبور باشید:</strong><br />
                        گاهی طول می‌کشد تا آن‌ها احساس‌شان را به زبان بیاورند، اما اگر فضا امن باشد، بسیار عمیق حرف خواهند زد.</p>

                    <p><strong>فیلم پیشنهادی:</strong><br />
                        "The Judge" قاضی، نمایش رابطه پرفرازونشیب پدری خشک، قاضی‌گونه و دقیق High C با پسرش، و تلاش برای ساختن پلی میان نظم و احساس.</p>
                </div>
            </Page>
        </>
    )
}

export default HighC